import {HUMANIA_EMMA_INSURER_CODE} from './providers';
import {Insurer} from '../insurer';

export enum InsuranceFirm {
  EMMA = 'EMMA',
  MOCK = 'MOCK',
}

export const insuranceFirmAgentInfo: Record<
  InsuranceFirm,
  {email: string; firstName: string; lastName: string; insurerCodes: Partial<Record<Insurer, string>>}
> = {
  [InsuranceFirm.EMMA]: {
    email: 'bonjour@emma.ca',
    firstName: 'Emma',
    lastName: 'Services Financiers Inc.',
    insurerCodes: {
      [Insurer.HUMANIA]: HUMANIA_EMMA_INSURER_CODE,
    },
  },
  [InsuranceFirm.MOCK]: {
    email: 'mock@emma.ca',
    firstName: 'Mock',
    lastName: 'Mock',
    insurerCodes: {},
  },
};
